import { PersonStore } from "fs-pb-vue2/store/modules/person";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { getModule } from "vuex-module-decorators";
import { UserSubscriptionData } from 'fs-pb-vue2/data/userSubscriptionData';
import { OperationRequestData } from 'fs-pb-vue2/data/operationRequestData';
import { DeclarationPropertiesTypes } from 'fs-pb-vue2/data/enums/declarationPropertiesTypes';
import { OperationsApi } from 'fs-pb-vue2/services/api/OperationsApi';
import { container } from "@/inversify.config";
import { SubscriptionEditVue } from "fs-pb-vue2/vueModels/subscription/SubscriptionEditVue";

export class SubscriptionEditVueGB extends SubscriptionEditVue {

  // stores:

  /** Стор приложения */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  // services:

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  // data:

  selectedCategory: any = null;

  formMode: string = '';

  isCategorySelected: boolean = false;

  previousFormMode: string = '';

  // computed:
  get docCategories() {
    const categories = this.docTypes.map(doc => doc.Category);
    return [...new Set(categories)];
  }

  get isNotUserSubscription() {
    return this.subscription.id !== 0 && !this.subscription.docNumber;
  }

  // methods:

  setFormMode(newMode: string): void {
    this.previousFormMode = this.formMode;
    this.formMode = newMode;
    if (this.$route.query.openCategorySelect === 'true') {
      this.formMode = 'createSubscription';
    } else if (this.subscription.id !== 0 && this.subscription.docNumber) {
      this.formMode = 'editSubscription';
    } else if (this.subscription.id !== 0 && !this.subscription.docNumber) {
      this.formMode = 'autoSubscription';
    } else if (!this.subscription.docType || !this.subscription.docType.Category) {
      this.formMode = 'selectCategory';
    }
  }

  selectCategoryGb(cat: any): void {
    this.isNew = true;
    this.selectedCategory = cat;
    this.subscription.docType.Category = cat;
    this.formMode = 'createSubscription';
    this.isCategorySelected = true;
  }

  async submitHandler() {
    try {
      await this.$refs.subsForm.validate();

      if (!this.isValidForm) return;

      this.loading = true;
      const savedItem: UserSubscriptionData = this.fillRequest();
      let ord: OperationRequestData = new OperationRequestData();
      let ordResp: any = new OperationRequestData();

      if (this.needConfirm) {
        ord.verificationCode = this.confirmCode;
        ord.operationId = this.operId;
      }

      if (this.isNew) {
        if (this.newId)
          ord.setProperty("subscriptionId", this.newId, DeclarationPropertiesTypes.String)
        ord = this.prepareSaveOrder(savedItem, ord);
        ordResp = await OperationsApi.operationSendAsync(
          'WebClient/SaveUserSubscription',
          ord
        );
        ordResp = new OperationRequestData(ordResp.data);
        this.newId = ordResp.getPropertyValue("subscriptionId");
      } else {
        if (!this.checkChanges()) {
          this.alertService.warning('Вы не произвели никаких изменений');
          this.loading = false;
          return;
        }
        ord = this.prepareEditOrder(savedItem, ord);
        ordResp = await OperationsApi.operationSendAsync(
          "WebClient/EditUserSubscription",
          ord
        );
        ordResp = new OperationRequestData(ordResp.data);
      }
      if (this.needConfirm || !ordResp.needConfirm) {
        this.alertService.success('Шаблон успешно сохранен');
        await this.personStore.fetchSubscriptions();

        this.destroyForm();
      } else {
        this.needConfirm = true;
        this.operId = ordResp.operationId;
      }

      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.alertService.error(e.message);
    }
  };

  async destroyForm(): Promise<void> {
    if (this.previousFormMode) {
      this.formMode = this.previousFormMode;
      this.previousFormMode = '';
    } else {
      this.$emit("hideSelf");
    }
  }
}
